import { combineReducers } from 'redux';

import stationsReducer, { StationsState } from '@app/store/data/Stations';

/* *********************** *
 *    Type definitions     *
 * *********************** */
export interface DataState {
  stations: StationsState;
}

/* ********************* *
 *    Define reducer     *
 * ********************* */

const dataReducer = combineReducers({
  stations: stationsReducer,
});

/* ********************* *
 *    Export reducer     *
 * ********************* */
export default dataReducer;
